import React from "react";

import { Col, Row } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { IoIosSettings, IoIosLogOut } from "react-icons/io";
import { GoDatabase } from "react-icons/go";

import UserAvatar from "../../common/components/UserAvatar";
import { PALETTE } from "../../common/ThemeConstants";


export default function SignedCard({ role, user, onSignOut }) {
  const navigate = useNavigate();
  return (
    <div className="shadow py-2 px-2 rounded-md">
      <Row>
        <Col xs={3} className="text-center m-0">
          <div className="m-auto" style={{ width: "fit-content" }}>
            <UserAvatar
              firstname={user.firstname}
              lastname={user.lastname}
              size={40}
              fontSize={14}
              shadow={false}
              background={PALETTE.GRADIENT}
              color={PALETTE.WHITE}
              cover={user.cover || undefined}
            />
          </div>
        </Col>
        <Col xs={9} className="text-start">
          <p style={{ fontWeight: "bold", marginBottom: 0, fontSize: 14 }}>{user.firstname.charAt(0).toUpperCase() + user.firstname.slice(1,)} {user.lastname.charAt(0).toUpperCase() + user.lastname.slice(1,)}</p>
          <p style={{ color: PALETTE.GRAY, fontSize: 14 }}>{user.email}</p>
          {role === "Admin" && (
            <div className="pb-1">
              <NavLink
                to="/account/Database"
                className="dropdown-item rounded-md"
                style={{ textDecoration: "none", color: PALETTE.LIGHTGRAY, width: "fit-content" }}
              >
                <GoDatabase size={22} className="me-1" style={{ paddingBottom: 1 }} />
                {`Admin`}
              </NavLink>
            </div>
          )}
          <p className="mb-1">
            <span
              onClick={() => navigate("/settings")}
              className="rounded-md py-1 px-2 me-1 align-self-center"
              style={{
                fontSize: 12,
                color: PALETTE.GRAY,
                backgroundColor: PALETTE.LIGHTGRAY,
                display: "inline-block",
                marginTop: 2,
                border: "1px solid " + PALETTE.LIGHTGRAY,
                cursor: "pointer",
              }}
            ><IoIosSettings size={22} className="me-1" style={{ paddingBottom: 1 }} />{`Impostazioni`}</span>
            <span
              onClick={onSignOut}
              className="rounded-md py-1 px-2 me-1 signout"
              style={{
                fontSize: 12,
                display: "inline-block",
                marginTop: 2,
                cursor: "pointer",
              }}
            ><IoIosLogOut size={22} className="me-1" style={{ paddingBottom: 1 }} />{`Esci`}</span>
          </p>
        </Col>
      </Row>
    </div>
  );
}
